const asArray = (value) => (Array.isArray(value) ? value : [])

export const getTasksDueToday = (tasks, now = new Date()) => {
  const currentDate = new Date(now)
  if (Number.isNaN(currentDate.getTime())) return []

  const startOfToday = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  )
  const startOfTomorrow = new Date(startOfToday)
  startOfTomorrow.setDate(startOfTomorrow.getDate() + 1)

  return asArray(tasks)
    .filter((task) => {
      const dueDate = new Date(task?.todoDueDate)
      return !Number.isNaN(dueDate.getTime())
        && dueDate >= startOfToday
        && dueDate < startOfTomorrow
    })
    .sort((taskA, taskB) => (
      new Date(taskA.todoDueDate).getTime() - new Date(taskB.todoDueDate).getTime()
    ))
}

export const getIncompleteSubtaskCount = (task) => asArray(task?.todoSubtasks)
  .filter((subtask) => subtask?.subtaskCompleted !== true)
  .length
